// START GENAI
.vs-content-card__3up-container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding-bottom: 80px;

  @media (max-width: 480px) {
    padding-bottom: 48px;
  }
}

.vs-content-card__3up-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 50px;
  width: 100%;

  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  .vsr-card {
    max-width: 100%;
    width: 100%;
    @media (max-width: 768px) {
      max-width: none;
    }
    .vsr-card__image-container {
      width: 100%;
      background: transparent;
      @media (max-width: 768px) {
        width: auto;
      }
      .vsr-card__image {
        width: 100%;
        max-width: none;
      }

      &:not(.no-hover-16-9) .vsr-card__image {
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      }
    }
  }

  // Product card styling for 3up layout
  vsr-product-card {
    max-width: 100%;
    width: 100%;

    .vsr-product-card {
      max-width: 100%;
      width: 100%;
    }

    .vsr-product-card__fixed-image {
      width: 100%;
      box-sizing: border-box;
      padding: 40px; /* Consistent padding for 3up layout */
      @media (max-width: 768px) {
        padding: 30px;
      }

      /* Preserve aspect ratio classes */
      &.aspect-ratio-1-1 {
        aspect-ratio: 1 / 1;
        height: auto;
      }

      &.aspect-ratio-3-4 {
        aspect-ratio: 3 / 4;
        height: auto;
      }

      &.aspect-ratio-4-3 {
        aspect-ratio: 4 / 3;
        height: auto;
      }

      &.aspect-ratio-4-5 {
        aspect-ratio: 4 / 5;
        height: auto;
      }

      &.aspect-ratio-16-9 {
        aspect-ratio: 16 / 9;
        height: auto;
      }

      /* Default height when no aspect ratio is specified */
      &:not([class*="aspect-ratio"]) {
        height: auto;
      }
    }

    .vsr-product-card__fixed-image img {
      max-width: 100%; /* Allow images to use available space */
      max-height: none;
      width: auto;
      height: auto;
    }
  }

  // Icon card styling for 3up layout
  vsr-icon-card {
    max-width: 100%;
    width: 100%;

    .vsr-icon-card_container {
      max-width: 100%;
      width: 100%;
      /* Remove padding - let icon card use its natural layout */
    }

    .vsr-icon-card_image img {
      /* Let icon card use its original image sizing */
      max-width: 64px;
      @media (min-width: 768px) {
        max-width: 100px;
      }
    }
  }
}

.vs-content-card__3up-card {
  width: 100%;
}

// END GENAI
